import { c as _c } from "react/compiler-runtime";
import { Button } from '@chakra-ui/react';
import { advisorsBreadcrumbsWithTrail, useAdvisorsToolbar } from '@src/components/sco/Advisors/hooks/useAdvisorsToolbar';
import { AdvisorsSubNavLayout } from '@src/components/sco/Advisors/layout/AdvisorsSubNavLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { MyFoundersSectionKey, myFoundersNavItems } from '@src/components/sco/Advisors/utils/myFoundersNav';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ReactNode } from 'react';
import { LuTarget } from 'react-icons/lu';

/**
 * My Founders shell (advisor supply side) — sub-nav rail plus section content.
 * Sibling of `BoardSeatsLayout` (My Advisors) on the shared `AdvisorsSubNavLayout`.
 */
export const MyFoundersLayout = t0 => {
  const $ = _c(11);
  const {
    activeKey,
    children
  } = t0;
  const paths = useAdvisorsPaths();
  const navItems = myFoundersNavItems(paths);
  const activeItem = navItems.find(item => item.key === activeKey) ?? navItems[0];
  useAdvisorsToolbar({
    breadcrumbs: activeKey === "active" ? advisorsBreadcrumbsWithTrail({
      title: "My Founders",
      href: paths.myFounders
    }) : advisorsBreadcrumbsWithTrail({
      title: "My Founders",
      href: paths.myFounders
    }, {
      title: activeItem.title,
      href: activeItem.href
    })
  });
  const T0 = AdvisorsSubNavLayout;
  const t1 = activeItem.description;
  const t2 = navItems.map(_temp);
  const t3 = activeItem.key === "active" ? "My Founders" : activeItem.title;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LuTarget />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== paths.opportunities) {
    t5 = <Button asChild={true} size="sm" variant="cta" width="full"><NextLink href={paths.opportunities}>{t4} Find more founders</NextLink></Button>;
    $[1] = paths.opportunities;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== T0 || $[4] !== activeItem.description || $[5] !== activeKey || $[6] !== children || $[7] !== t2 || $[8] !== t3 || $[9] !== t5) {
    t6 = <T0 activeKey={activeKey} description={t1} items={t2} railDescription="Founders whose boards you sit on." railTitle="My Founders" title={t3} railFooter={t5}>{children}</T0>;
    $[3] = T0;
    $[4] = activeItem.description;
    $[5] = activeKey;
    $[6] = children;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp(t0) {
  const {
    key,
    title,
    href,
    icon
  } = t0;
  return {
    key,
    title,
    href,
    icon
  };
}